class SchoolStorage {
  static getSchool() {
    const schoolId = localStorage.getItem('schoolId');
    const schoolName = localStorage.getItem('schoolName');
    const schoolLogo = localStorage.getItem('schoolLogo');
    return { schoolId, schoolName, schoolLogo };
  }

  static setSchool(schoolId, schoolName, schoolLogo) {
    localStorage.setItem('schoolId', schoolId);
    localStorage.setItem('schoolName', schoolName);
    localStorage.setItem('schoolLogo', schoolLogo);
  }

  static clearSchool() {
    localStorage.removeItem('schoolId');
    localStorage.removeItem('schoolName');
    localStorage.removeItem('schoolLogo');
  }
}

export default SchoolStorage;
